import React, { HTMLAttributes } from "react";
// import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import Banner1 from "@/assets/images/aboutus/banner1.png"
const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Infused: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  // const {isLogin} = store.user;

  return (
    <div className={cx(styles.picbox, className)} style={{ backgroundImage: `url(${Banner1})` }}>
      <div className={cx(styles.flexCenter, className)}>
        <div className={cx(styles.titleBox, className)} style={{ maxWidth: "1140px"}}>
          <div style={{fontSize: "70px"}}>XT.COM</div>
          <div style={{marginTop: "30px"}}>{ t("cmpt.socialExchange") }</div>
        </div>
      </div>
      <div className={cx(styles.flexCenter, className)}>
        <div className={cx(styles.desBOX, className)} style={{ maxWidth: "1034px"}}>
          <div>
            {t("aboutus.xtIntroduce1") }
          </div>
          <div style={{margin: '30px 0'}}>
            {t("aboutus.xtIntroduce2") }
          </div>
          <div className={cx(styles.flexCenter, className)}>
            <div style={{width: "644px"}}>{t("aboutus.xtIntroduce3") }</div>
          </div>
        </div>
      </div>
      <div className={cx(styles.Statistics, className)}>
        <div className={cx(styles.blockStatis, className)}>
          <div className={cx(styles.top, className)}>1000+</div>
          <div className={cx(styles.bottom, className)}>{ t("aboutus.tradingpairs") }</div>
        </div>
        <div className={cx(styles.blockStatis, className)}>
          <div className={cx(styles.top, className)}>6,000,000+</div>
          <div className={cx(styles.bottom, className)}>{ t("aboutus.RegisteredUsers") }</div>
        </div>
        <div className={cx(styles.blockStatis, className)}>
          <div className={cx(styles.top, className)}>40,000,000+</div>
          <div className={cx(styles.bottom, className)}>{ t("aboutus.XTEcosystemUsers") }</div>
        </div>
        <div className={cx(styles.blockStatis, className)}>
          <div className={cx(styles.top, className)}>7/24</div>
          <div className={cx(styles.bottom, className)}>{ t("aboutus.Service") }</div>
        </div>
      </div>
    </div>
  );
};

export default Infused
// export default Main;
